import React from 'react';
import { Field } from 'formik';

import styles from './cardFormStyles';

import CharacterLimit from 'buyside/components/presentation/CharacterLimit/CharacterLimit';
import ImageField from 'buyside/components/presentation/Form/Field/ImageField/imageField';
import CityAutocomplete from 'buyside/components/presentation/CityAutocomplete/cityAutocomplete';
import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';

// NOTE: make sure to update the appropriate schema in util/userProfileShowPageValidationSchemata

const CardForm = ({ values: { userProfile }, setFieldValue }) => {
  const { imageData, croppedImageData, imageUrl, imageProfileUrl, defaultImage } = userProfile;
  const imageNote = 'Optimal image size is 250px by 250px.';
  const summaryLength = userProfile.summary && userProfile.summary.length;
  return (
    <div data-testid="user-profile-form">
      <Field
        component={ImageField}
        name="userProfile"
        label="Profile Picture"
        title="picture"
        image={imageData || imageUrl}
        croppedImage={croppedImageData || imageProfileUrl}
        defaultImage={defaultImage}
        isCircular
        note={imageNote}
      />
      <div className={styles.cardFormCity}>
        <CityAutocomplete name="userProfile.city" setFieldValue={setFieldValue} />
      </div>
      <div className={styles.cardFormSummary}>
        <Field component={InputField} name="userProfile.summary" type="textarea" label="Bio" />
        <CharacterLimit textLength={summaryLength} limit={1250} />
      </div>
    </div>
  );
};

export default CardForm;
